import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey : vars.google_map_key,
  version: "weekly",
  libraries: ["places"]
});

export default loader.load();
